import "../../libraries/jqueryPasswordRequirements";
// Profile & Login Page

export function initLogin() {
  authPopupListener();
  safely(passwordRules);
  safely(togglePasswordView);
  if (window.location.pathname != "/users/sign_in") {
    safely(passwordMatchListener);
  }
  safely(checkIfThirdPartyCookiesEnabled);
}

function safely(fn) {
  try {
    fn();
  } catch (e) {
    window.Honeybadger?.notify(e);
  }
}

function checkIfThirdPartyCookiesEnabled() {
  parent.postMessage(
    {
      messageType: "cookiesEnabledCheck",
      thirdPartyCookiesEnabled: navigator.cookieEnabled,
    },
    "*"
  );
}

function passwordRules() {
  var container = $("#ps_box_container");

  $(".login .password-rules-input").passwordRequirements({
    inputElement: $(".password-rules-input"),
    containerElement: container,
    reuseCheckText: container.data("reuseCheckText"),
    passwordReused: container.data("passwordReused") === true,
  });
}

function togglePasswordView() {
  $(".login .js-toggle-password-view").off("click");
  $(document).on("click", ".login .js-toggle-password-view", function () {
    var parentInput = $(this).closest(".password-view-toggle-container");
    if (
      parentInput.find('input[name="user[password]"]').attr("type") ==
        "password" ||
      parentInput
        .find('input[name="user[password_confirmation]"]')
        .attr("type") == "password"
    ) {
      parentInput.find('input[name="user[password]"]').attr("type", "text");
      parentInput
        .find('input[name="user[password_confirmation]"]')
        .attr("type", "text");
      parentInput.find(".eye-password-icon-open").hide();
      parentInput.find(".eye-password-icon-closed").show();
    } else if (
      parentInput.find('input[name="user[password]"]').attr("type") == "text" ||
      parentInput
        .find('input[name="user[password_confirmation]"]')
        .attr("type") == "text"
    ) {
      parentInput.find('input[name="user[password]"]').attr("type", "password");
      parentInput
        .find('input[name="user[password_confirmation]"]')
        .attr("type", "password");
      parentInput.find(".eye-password-icon-closed").hide();
      parentInput.find(".eye-password-icon-open").show();
    }
  });
}

function authPopupListener() {
  $(document).on("click", "#auth-popup", function (e) {
    const redirectUrl = document
      .getElementById("auth-popup")
      .getAttribute("url");
    const popupWidth = 600;
    const popupHeight = 700;
    const left = (screen.width - popupWidth) / 2;
    const top = (screen.height - popupHeight) / 4;
    window.open(
      redirectUrl,
      "authPopup",
      `menubar=no,toolbar=no, width=${popupWidth}, height=${popupHeight}, top=${top}, left=${left}`
    );
  });
}

function validatePassword() {
  var passwordsMatch =
    $("#user_password").val() == $("#user_password_confirmation").val();
  var fieldsNotEmpty =
    $("#user_password").val().length &&
    $("#user_password_confirmation").val().length;
  var newPasswordValid =
    $(".login #ps_box_container .pr-met").length == 6;

  if (passwordsMatch && fieldsNotEmpty && newPasswordValid) {
    return true;
  }
  return false;
}

function showPasswordErrors() {
  var passwordFieldsMatch =
    $("#user_password").val() == $("#user_password_confirmation").val();

  if (!passwordFieldsMatch) {
    $("#password_match_error").removeClass("hidden").show();
  } else {
    $("#password_match_error").addClass("hidden").hide();
  }
}

function hidePasswordErrors() {
  $("#password_match_error").hide();
  $(".error-msg-container label").show();
}

function passwordMatchListener() {
  var submitPasswordChangeButton = $(
    ".login form input[value='Change my password'], .login form input[value='Update Password'], #finish-account-setup"
  );
  submitPasswordChangeButton
    .removeClass("primary-btn")
    .addClass("disabled-btn");
  $(document).on(
    "keyup",
    ".login #user_password, .login #user_password_confirmation",
    function () {
      var validPassword = validatePassword();
      if (validPassword) {
        hidePasswordErrors();
        submitPasswordChangeButton
          .addClass("primary-btn")
          .removeClass("disabled-btn");
      } else {
        showPasswordErrors();
        submitPasswordChangeButton
          .removeClass("primary-btn")
          .addClass("disabled-btn");
      }
    }
  );
}
